<ng-container [ngTemplateOutlet]="selected.content"></ng-container>
